module.exports = __webpack_public_path__ + "img/a1-bg3.f63c1dc8.jpg";